export default __webpack_public_path__ + "static/media/featureimg.714bc6e7.png";